import commonHelper from '@/app/utility/common.helper.utility';
import awardDetails from './awardDetails';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import sendForApproval from '@/app/components/onlineApproval/internalWorkFlow/history/sendForApproval';

export default {
  name: 'awardSummary',
  props: [
    'rfpHeaderId',
    'rankedVendors',
    'headerAllData',
    'locationAllData',
    'poWriteAccess',
    'negotiationHeaderIdData'
  ],
  components: {
    awardDetails,
    UploadDocument,
    HistoryRecord,
    ApprovalHistory,
    sendForApproval
  },
  data() {
    return {
      loading: false,
      totalRows: null,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      showBtn: false,
      awardData: [],
      awardFields: [
        {
          key: 'select',
          variant: 'info',
          stickyColumn: true
        },
        {
          key: 'rfp_award_vendor_email',
          label: 'Vendor Email'
        },
        {
          key: 'rfp_award_vendor_name',
          label: 'Vendor Name'
        },
        {
          key: 'vendor_code',
          class: 'col-fix-small text-left'
        },
        {
          key: 'rank',
          label: 'Level',
          class: 'col-fix-small text-left'
        },
        {
          key: 'details',
          class: 'col-fix-small text-left'
        }
      ],
      rfpAwardVendorId: null,
      selectedIndex: null,
      awardDetailsModal: false,
      remarksModal: false,
      remarks: null,
      rowData: null,
      showWorkflowHistory: false,
      selectedRfpDetails: {},
      workflowHistoryType: null,
      menuIdForRfpAward: null,
      editMode: true,
      approvalStatusFlag: false,
      showHistory: false,
      historyType: null,
      selectedGridData: {
        le_id: '67',
        le_name: 'Delhivery Limited',
        nfa_cat_vset: null,
        nfa_cat: null,
        nfa_sub_cat_vset: null,
        nfa_sub_cat: null
      },
      documentList: [],
      userId: null,
      ownersData: [],
      negotiationHeaderId: null
    };
  },
  mounted() {
    this.userId = this.$store.state.auth.userId;
    this.getAwardSummaryData();
    this.getAwardSummaryDtlById();
    this.getOwnersData();
  },
  watch: {
    currentPage: function() {
      this.getAwardSummaryData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getAwardSummaryData();
    }
  },
  methods: {
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: 'Alert',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true,
        toastClass: 'custom-toast',
        autoHideDelay: 2000
      });
    },
    getAwardSummaryData() {
      let payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getAwardSummaryData', payload)
        .then(response => {
          if (response.status === 200) {
            this.loading = false;
            this.awardData = response.data.data;
            let mergedData = this.awardData.map(awardVendor => {
              let rankInfo = this.rankedVendors.find(
                rank => rank.vendor === awardVendor.rfp_award_vendor_name
              );
              return {
                ...awardVendor,
                rank: rankInfo ? rankInfo.rank : 'N/A',
                total: rankInfo ? rankInfo.total : 'N/A',
                _rowVariant:
                  rankInfo && rankInfo.rank === 'L1' ? 'success' : null
              };
            });
            this.awardData = mergedData;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectedAwardDetail(item, index) {
      for(let i of this.negotiationHeaderIdData[0].vendor_details) {
         if(item.rfp_award_vendor_name === i.vendor_name) {
          this.negotiationHeaderId = i.negotiation_hdr_id;
         }
      }
      this.selectedIndex = index;
      this.selectedDetails = Object.assign({}, item);
      this.showBtn = true;
    },
    alotAwardDetail() {
      if (this.remarks === null || this.remarks === '') {
        alert('Remarks Mandatory');
      } else {
        let amount = this.selectedDetails.total;
        let decimal_value = parseFloat(
          parseFloat(amount.replace('₹', '')).toFixed(2)
        );
        const poTypeDetails = [
          {
            rfp_award_vendor_id: this.rfpAwardVendorId
              ? this.rfpAwardVendorId
              : 0,
            rfp_vendor_id: this.selectedDetails.rfp_vendor_id,
            rfp_award_vendor_name: this.selectedDetails.rfp_award_vendor_name,
            rfp_award_vendor_email: this.selectedDetails.rfp_award_vendor_email,
            vendor_code: this.selectedDetails.vendor_code,
            is_delete: 0,
            rfp_award_vendor_remarks: this.remarks,
            total_amount: decimal_value.toFixed(2),
            level: this.selectedDetails.rank,
            negotiation_hdr_id: this.negotiationHeaderId
          }
        ];
        const payload = {
          rfp_header_id: this.rfpHeaderId,
          rfp_vendor_award_dtls: poTypeDetails ? poTypeDetails : null
        };
        this.loading = true;
        this.$store
          .dispatch('rfp/alotAwardDetail', payload)
          .then(response => {
            this.loading = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.makeToast('Request Completed Successfully', 'success');
              this.getAwardSummaryData();
              this.getAwardSummaryDtlById();
              this.$emit('openAwardSummaryModal', false);
              this.remarksModal = false;
            }
          })
          .catch(() => {
            this.loading = false;
            this.makeToast('Something went wrong', 'danger');
          });
      }
    },
    getAwardSummaryDtlById() {
      const payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getAwardSummaryDtlById', payload)
        .then(resp => {
          this.loading = false;
          if (resp.status === 200) {
            this.menuIdForRfpAward = resp.data.data[0].menu_id;
            this.selectedAwardData = resp.data.data;
            if (
              this.selectedAwardData[0].approval_status === 'INPROCESS' ||
              this.selectedAwardData[0].approval_status === 'APPROVED'
            ) {
              this.editMode = false;
            } else {
              this.editMode = true;
            }
            if (
              this.selectedAwardData[0].approval_status === 'APPROVED' &&
              this.selectedAwardData[0].acceptance_flag === 1
            ) {
              this.approvalStatusFlag = true;
            }
            this.rfpAwardVendorId = resp.data.data[0].rfp_award_vendor_id;
            this.totalRows = resp.data.data.total_elements;
            this.getUploadedDocDtl();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openCloseAwardDetailsModal(flag, item) {
        this.rowData = item;
        this.awardDetailsModal = flag;
  },
    openCloseRemarksModal(flag) {
      this.remarksModal = flag;
    },
    showHideWorkflowHistory(flag, historyType) {
      if (
        (this.selectedRfpDetails.approval_status === 'INPROCESS' ||
          this.selectedRfpDetails.approval_status === 'NOTREQUIRED' ||
          this.selectedRfpDetails.approval_status === 'APPROVED') &&
        historyType === 'uploadDocument'
      ) {
        alert('You Cannot Upload Document in this Stage');
      } else {
        this.showWorkflowHistory = flag;
        this.workflowHistoryType = historyType;
      }
    },
    getOpenKmAuthTokenUploadDocument() {
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.showHideHistory(true, 'invoice');
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
      this.getUploadedDocDtl();
    },
    getUploadedDocDtl() {
      const payload = {
        _page: 0,
        _limit: 100,
        menu_id: this.$store.state.shared.menuId,
        sub_menu_id: 94,
        record_id: this.rfpAwardVendorId
      };
      this.documentData = [];
      this.$store
        .dispatch('intWorkflow/getOpenKmDocDtl', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data.page.length > 0) {
              const docList = response.data.data.page;
              this.documentList = response.data.data.page;
              this.documentData = docList.map(data => {
                data.file_size = this.formatBytes(data.file_size);
                return data;
              });
              // this.totalRows = response.data.data.total_elements;
            } else {
              // alert('Document not available for this record');
              this.$emit('closeModal');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOwnersData() {
      const payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getOwnersData', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            this.ownersData = response.data.data;
          }
        })
        .catch(() => {
          this.loading = false;
          this.makeToast('Something went wrong', 'danger');
        });
    },
  },
  beforeDestroy() {}
};
